import { Profiler, useCallback, type PropsWithChildren, type ProfilerOnRenderCallback } from 'react';
import { record } from './profilerAggregator';
import { useFeatureToggle } from '../utils/useFeatureToggle';

type ConditionalProfilerProps = PropsWithChildren<{
    id: string;
}>;

export const ConditionalProfiler: React.FC<ConditionalProfilerProps> = ({ id, children }) => {
    const enabled = useFeatureToggle('enableMVReactProfiler');

    const onRender: ProfilerOnRenderCallback = useCallback((_id, phase, actualDuration, baseDuration) => {
        record(_id, phase, actualDuration, baseDuration);
    }, []);

    if (!enabled) {
        return children;
    }

    return (
        <Profiler id={id} onRender={onRender}>
            {children}
        </Profiler>
    );
};
